import React, { ChangeEvent, FunctionComponent } from "react";
import styled from "styled-components";
import { CheckboxProps, RadioGroupPros } from "../../interfaces/interfaces";

interface RadioProps extends CheckboxProps {
  labelAfterRadio?: boolean;
}

const Radio: FunctionComponent<RadioProps> = ({
  name,
  id,
  value,
  placeholder,
  onChange,
  className,
  checked,
  label,
  required,
  labelAfterRadio = false,
}) => {
  const placeholder_ = `${placeholder}${required ? "*" : ""}`;
  return (
    <div className={className}>
      {!labelAfterRadio && <label htmlFor={id}>{label}</label>}
      <label className="container2">
        <input
          required={required}
          type="radio"
          checked={checked}
          name={name}
          id={id}
          value={value}
          placeholder={placeholder_}
          onChange={onChange}
        />
        <span className="checkmark2"></span>
      </label>
      {labelAfterRadio && <label htmlFor={id}>{label}</label>}
    </div>
  );
};

const RadioGroup: FunctionComponent<RadioGroupPros> = ({
  options,
  onChange,
  required,
  className,
}) => {
  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    let { name, value } = event.target;
    // TODO: Just send back { name, value, ..etc }
    onChange && onChange({ [name]: value });
  };

  return (
    <StyledRadioGroupWrapper className={className} onChange={handleOnChange}>
      {options.map((option, index) => (
        <Radio key={index} required={required} {...option} />
      ))}
    </StyledRadioGroupWrapper>
  );
};

const StyledRadioGroupWrapper = styled.div`
  display: flex;
  font-family: sofia-pro,sans-serif;
  color: #9e9e9e;
  /* The container */
  .container2 {
    display: inline-block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default radio button */
  .container2 input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* Create a custom radio button */
  .checkmark2 {
    position: absolute;
    top: -5px;
    left: 10px;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }

  /* On mouse-over, add a grey background color */
  .container2:hover input ~ .checkmark2 {
    background-color: #ccc;
  }

  /* When the radio button is checked, add a blue background */
  .container2 input:checked ~ .checkmark2 {
    background-color: #8733ff;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark2:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .container2 input:checked ~ .checkmark2:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .container2 .checkmark2:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
  div {
    margin-right: 40px;
  }
`;

export default Radio;
export { RadioGroup };
